export const ADMIN_REVIEW_PATH = '/admin/community-reviews/review';

export const MOTION_REVIEW_SECTIONS = [
  ['needsReview', 'Needs staff'],
  ['flagged', 'Flagged'],
  ['autoFlagged', 'Auto flagged'],
  ['open', 'All open'],
  ['closed', 'Completed'],
  ['all', 'All clips'],
];

export const AUTO_FLAGGED_REVIEW_DIRECTIONS = [
  ['all', 'All disagreements'],
  ['communityFalse', 'Community: false alarm / AI: real motion'],
  ['communityReal', 'Community: real motion / AI: false alarm'],
];

export function buildAdminReviewUrl(filter, direction = 'all') {
  if (!MOTION_REVIEW_SECTIONS.some(([value]) => value === filter)
    || !AUTO_FLAGGED_REVIEW_DIRECTIONS.some(([value]) => value === direction)
    || (filter !== 'autoFlagged' && direction !== 'all')) {
    throw new RangeError('Choose a valid motion review section.');
  }
  const params = new URLSearchParams({ filter });
  if (filter === 'autoFlagged' && direction !== 'all') params.set('autoFlaggedDirection', direction);
  return `${ADMIN_REVIEW_PATH}?${params.toString()}`;
}

export function getAdminReviewSelection(search) {
  const params = new URLSearchParams(search);
  if ([...params.keys()].some((key) => !['filter', 'autoFlaggedDirection'].includes(key))
    || params.getAll('filter').length !== 1
    || params.getAll('autoFlaggedDirection').length > 1) return null;
  const filter = params.get('filter');
  const section = MOTION_REVIEW_SECTIONS.find(([value]) => value === filter);
  if (!section || (filter !== 'autoFlagged' && params.has('autoFlaggedDirection'))) return null;
  const autoFlaggedDirection = params.get('autoFlaggedDirection') ?? 'all';
  const direction = AUTO_FLAGGED_REVIEW_DIRECTIONS.find(([value]) => value === autoFlaggedDirection);
  if (!direction) return null;
  return {
    filter,
    autoFlaggedDirection,
    title: filter === 'autoFlagged' ? `${section[1]} · ${direction[1]}` : section[1],
  };
}
